import { combineReducers } from 'redux';
import resetpassword from './resetpassword/reducer.js';
import auth from './auth/reducer.js';
import usuario from './usuario/reducer.js';
import player from './player/reducer.js';
import dialog from './dialog/reducer.js';

export interface IRootState {
  resetpassword: typeof resetpassword;
  auth: typeof auth;
  usuario: typeof usuario;
  player: typeof player;
  dialog: typeof dialog;
}

export default combineReducers({
  resetpassword,
  auth,
  usuario,
  player,
  dialog,
});
